export const getBidTableRows = ({ mrqData, bidData, existedPos, plant }) => {
  console.log("ffrom getbidrows:", { mrqData, bidData, existedPos });
  const result = mrqData?.mrqMaterials?.map((m, i) => {
    let obj = {};
    let poData = {};
    let estData = [];

    plant.projects?.forEach((project) => {
      const hasEst =
        project?.revisions?.[0]?.data?.estimationTable?.[0]?.Summary?.[0];

      if (hasEst) {
        console.log(
          "est project data",
          project?.revisions?.[0]?.data?.estimationTable?.[0]?.Summary?.[0],
        );
        const SummaryData =
          project?.revisions?.[0]?.data?.estimationTable?.[0]?.Summary;

        SummaryData.forEach((row) => {
          estData.push({
            description: row.MaterialDescription,
            budgetedCost: row.pmBudgetedCost,
          });
        });
      }
    });

    // console.log({ estData: estData });
    bidData.forEach((b) => {
      if (b.mrqMaterialId === m.id) {
        obj[b.vendor.name] = {
          vendorId: b.vendorId,
          time: b.time,
          cost: b.cost,
          submittedDataSheet: b.submittedDataSheet,
        };
        return obj[b.vendor.name];
      }
    });

    existedPos[0] &&
      existedPos[0].id &&
      existedPos.forEach((po) => {
        po.poMaterials.forEach((poMaterial) => {
          if (m.id === poMaterial.mrqMaterialId) {
            const record = bidData.filter(
              (m) =>
                m.vendor.name === poMaterial.vendor.name &&
                m.mrqMaterialId === poMaterial.mrqMaterialId,
            )[0];
            const time = record?.time;
            const cost = record?.cost;

            poData = {
              selected: {
                name: poMaterial.vendor.name,
                time,
                cost,
              },
              po: po.poNumber,
              poId: po.id,
              vendorId: poMaterial.vendor.id,
            };
          }
        });
      });

    // console.log({
    //   md: mrqData?.mrqMaterials?.map((m) => m.description),
    //   est: estData.map((r) => ({ d: r.description, c: r.cost })),
    //   isDone: m.description === estData[5]?.description,
    // });

    console.log("estData plant", estData);

    const estCost =
      estData.find((r) => {
        console.log({ r, m });
        return (
          r.description === m.description &&
          r["Cost Code"] === m?.materials?.[0]?.costCode
        );
      })?.cost * m.quantity || "";

    const unit = (m) => {
      const isPlate = m?.description?.toLowerCase().includes("plate");
      const isPipe = m?.description?.toLowerCase().includes("pipe");
      const isHead = m?.materials?.[0]?.costCode
        ?.toLowerCase()
        .includes("head");

      if (isPlate) {
        return "Ft²";
      } else if (m.unit) {
        return m.unit;
      } else if (isPipe && !isHead) {
        return "mm";
      } else {
        return "Nos";
      }
    };

    const tagNumber = m.materials?.map((m, i) => {
      return m.taggedMaterial?.tagNumber + ", ";
    });

    const row = {
      mrqMaterialId: m.id,
      materialCode: m.materialCode,
      tagNumber,
      costCode: m.materials?.[0]?.costCode,
      description: m.description,
      material: m.materials?.[0],

      remarks: m.remarks,
      qty: m.procuredQty,
      unit:
        (mrqData?.mrqMaterials &&
        !mrqData?.mrqMaterials[0]?.materials?.some(
          (row) => row?.tagNumber && String(row.tagNumber).trim() !== "-",
        )
          ? m.procuredUnit
          : "Nos") || "Nos",
      wbs: m.wbs || mrqData?.wbs,
      budgetedCost: estData.find((row) => row.description === m.description)
        ?.budgetedCost,
      ...obj,
      ...poData,
      est: m.estCost,
    };

    return row;
  });
  console.log({ result });
  return result && result[0] ? result : [];
};
